const testimonials = [
  {
    name: "Christie B.",
    location: "Edmond, OK",
    rating: 5,
    text: "Family of 5 needed passports renewed for our European river cruise. Fast Passport Center turned everything around in 7 days. Absolute lifesavers!",
    service: "Family Renewal",
  },
  {
    name: "Michael A.",
    location: "Oak Tree, Edmond",
    rating: 5,
    text: "Business trip to Singapore booked last minute. They got my renewal done in 3 days. Faster and cheaper than anything else I found.",
    service: "Emergency Renewal",
  },
  {
    name: "Sarah L.",
    location: "UCO Student, Edmond",
    rating: 5,
    text: "First passport for study abroad in Germany. The step-by-step guide for the Edmond Post Office was incredibly helpful. Got it in 6 days!",
    service: "First-Time Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function EdmondTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Edmond Travelers Say About Our Emergency & Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Edmond, Oak Tree, Coffee Creek, and UCO students who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}